import { render } from "./CodeExample.vue?vue&type=template&id=483c7301"
import script from "./CodeExample.vue?vue&type=script&lang=js"
export * from "./CodeExample.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__